import React from "react";
import { Button } from "@mui/material";
import "./SiButton.scss";
import { parseColorValue } from "../utils/parseColorValue";

export class SiButton extends React.Component<{
  onClick?: () => void;
  disabled?: boolean;
  classes?: string;
  large?: boolean;
  small?: boolean;
  themeColorOverride?: string;
  secondary?: boolean;
  fullWidth?: boolean;
  submitOnClick?: boolean;
}> {
  
  get className() {
    const { classes } = this.props;
    let className = `${classes ? classes : ""} si-button`;
    const { large, small, secondary } = this.props;

    if (large) className += " large";
    if (small) className += " small";
    if (secondary) className += " secondary";

    return className;
  }

  render() {
    const {
      children,
      disabled,
      onClick,
      large,
      small,
      fullWidth,
      themeColorOverride,
      submitOnClick = false,
    } = this.props;
    const size = large ? "large" : small ? "small" : "medium";
    const colorStyle = themeColorOverride ? `${parseColorValue(themeColorOverride)} !important` : "inherit"

    if (submitOnClick) {
      return (
        <Button
          type="submit"
          fullWidth={fullWidth}
          disabled={disabled}
          className={this.className}
          size={size}
          onClick={onClick}
          sx={{ backgroundColor: colorStyle}}
        >
          {children}
        </Button>
      );
    } else {
      return (
        <Button
          fullWidth={fullWidth}
          disabled={disabled}
          className={this.className}
          size={size}
          onClick={onClick}
          sx={{ backgroundColor: colorStyle}}
        >
          {children}
        </Button>
      );
    }
  }
}
